<p-toast></p-toast>

@if (!embedded) {
  <app-page-shell>
    <app-page-hero eyebrow="CRM Merchandisers" [title]="merchandiserId() ? 'Edit Merchandiser' : 'New Merchandiser'" subtitle="Maintain merchandiser records independently from Customer users.">
      <div actions>
        <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="cancel()"></p-button>
        <p-button label="Save Merchandiser" icon="pi pi-check" [loading]="saving()" [disabled]="saving()" (click)="save()"></p-button>
      </div>
    </app-page-hero>

    <ng-container *ngTemplateOutlet="merchandiserFormBody"></ng-container>
  </app-page-shell>
} @else {
  <div class="p-2">
    <div class="mb-3">
      <div class="text-900 text-xl font-semibold">{{ merchandiserId() ? 'Edit Merchandiser' : 'New Merchandiser' }}</div>
      <div class="text-600 mt-1">Create and assign a merchandiser for the selected CRM client and account.</div>
      @if (contextClientName || contextAccountName) {
        <div class="text-700 mt-2">
          {{ contextClientName || 'CRM Client not selected' }}
          @if (contextAccountName) {
            <span> / {{ contextAccountName }}</span>
          }
        </div>
      }
    </div>
    <ng-container *ngTemplateOutlet="merchandiserFormBody"></ng-container>
    <div class="flex justify-content-end gap-2 mt-3">
      <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="cancel()"></p-button>
      <p-button label="Save Merchandiser" icon="pi pi-check" [loading]="saving()" [disabled]="saving()" (click)="save()"></p-button>
    </div>
  </div>
}

<ng-template #merchandiserFormBody>
  <form [formGroup]="form" class="p-fluid">
    <app-page-form-section icon="pi pi-id-card" title="Merchandiser Profile" subtitle="Identity, contact, region, and active status.">
      <div class="grid">
        <div class="field col-12 md:col-6">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="merchandiserName" pInputText formControlName="name">
              <label for="merchandiserName">Name</label>
            </p-iftaLabel>
          </p-inputGroup>
          @if (submitted() && form.get('name')?.invalid) {
            <small class="p-error block mt-1">Name is required.</small>
          }
        </div>

        <div class="field col-12 md:col-6">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="employeeCode" pInputText formControlName="employeeCode">
              <label for="employeeCode">Employee Code</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-envelope"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="emailAddress" pInputText formControlName="emailAddress">
              <label for="emailAddress">Email</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-phone"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="phoneNumber" pInputText formControlName="phoneNumber">
              <label for="phoneNumber">Phone</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-mobile"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="mobileNumber" pInputText formControlName="mobileNumber">
              <label for="mobileNumber">Mobile</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="region" pInputText formControlName="region">
              <label for="region">Region</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>

        <div class="field col-12 md:col-6">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="active" formControlName="active" [options]="activeOptions" optionLabel="label" optionValue="value" styleClass="w-full"></p-select>
              <label for="active">Status</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>

        <div class="field col-12">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-align-left"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="notes" pInputText formControlName="notes">
              <label for="notes">Notes</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
      </div>
    </app-page-form-section>
  </form>
</ng-template>
